import type { TableComponentSpec, TableBuilderMisc } from "../Processing/types";
import type { ControlPanelHandler } from "../widgetContract";
import { isBound, widgetDatePatch } from "./_shared";

export const tableControlPanel: ControlPanelHandler<TableComponentSpec> = (spec, patch) => {
  spec.table_builder_misc = {
    ...(spec.table_builder_misc as TableBuilderMisc),
    ...(patch.applyDate && !isBound(spec.table_builder_misc, "date", patch) && widgetDatePatch(patch.date)),
    ...(patch.applySubjects && !isBound(spec.table_builder_misc, "subject", patch) && patch.subjects),
  };
};
